import connector from './nativeInterface';


export function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  if ((/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'ios';
  }
  return 'unknown';
}

export function jsonReplacer(key, value) {
  if (value === '' || value === null) {
    return undefined;
  }
  return value;
}

// 获取地址链接
export function getQueryString(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}


// nativeAjax原生方法封装
export function nativeAjax(obj) {
  const fnName = obj.callbackName;
  if (window[fnName]) {
    // eslint-disable-next-line no-console
    console.log('回调名称已经存在～');
  } else {
    window[fnName] = obj.callback;
  }
  const msg = {
    action: 3,
    data: {
      uri: obj.url,
      body: obj.data,
      callback: `${fnName}`,
      close: obj.close || 0, // 是否立即关闭webview，如果==1需要收到此action后立即关闭webview（但接口数据仍需发送给后端）
    },
  };
  try {
    connector.postMessage(msg);
  } catch (error) {
    connector[fnName] = obj.callback;
  }
}
function addZero(m) {
  return m < 10 ? `0${m}` : m;
}

export function timestampToTime(timestamp) {
  if (timestamp) {
    const time = new Date(timestamp * 1000);
    const y = time.getFullYear();
    const M = time.getMonth() + 1;
    const d = time.getDate();
    const h = time.getHours();
    const m = time.getMinutes();
    const s = time.getSeconds();
    return `${y}-${addZero(M)}-${addZero(d)} ${addZero(h)}:${addZero(m)}:${addZero(s)}`;
  }
  return '';
}




// WEBPACK FOOTER //
// ./src/common/js/utils.js